import React from 'react';
import ReactDOM from 'react-dom/client';
import AppWeb from './AppWeb';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWeb />
  </React.StrictMode>
);
